if (!customElements.get('bebeomi-sticky-atc')) {
  customElements.define(
    'bebeomi-sticky-atc',
    class BebeomiStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.label = this.dataset.label || 'Shto në shportë';
        this.price = this.querySelector('[data-sticky-price]');
        this.button = this.querySelector('[data-sticky-button]');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

        if (!this.button || !this.mainButton) return;

        this.button.addEventListener('click', () => this.mainButton.click());
        this.mainButtonObserver = new MutationObserver(() => this.syncButton());
        this.mainButtonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-disabled'],
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId === this.sectionId) this.sync();
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.mainButtonObserver?.disconnect();
        this.unsubscribe?.();
      }

      sync() {
        const priceRoot = document.getElementById(`price-${this.sectionId}`);
        const currentPrice =
          priceRoot?.querySelector('.price-item--sale') || priceRoot?.querySelector('.price-item--regular');
        if (currentPrice && this.price) this.price.textContent = currentPrice.textContent.trim();
        this.syncButton();
      }

      syncButton() {
        const isDisabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const isLoading = this.mainButton.classList.contains('loading');
        this.button.disabled = isDisabled;
        this.button.setAttribute('aria-busy', String(isLoading));
        this.button.textContent = isLoading ? 'Duke shtuar…' : isDisabled ? 'Nuk ka stok' : this.label;
      }
    }
  );
}

// Bebeomi: on phones, when a colour swatch is tapped, bring the product photo fully into
// view right away (below the sticky header) instead of waiting for the variant to load.
// media-gallery.js re-checks the position once the new photo is active.
if (!window.bebeomiSwatchScroll) {
  window.bebeomiSwatchScroll = true;
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    if (!input.closest('variant-selects .product-form__input--swatch')) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const gallery = input.closest('product-info')?.querySelector('media-gallery');
    if (!gallery) return;

    const offset = Array.from(
      document.querySelectorAll('.shopify-section-group-header-group, sticky-header')
    ).reduce((max, el) => {
      const pos = getComputedStyle(el).position;
      return pos === 'sticky' || pos === 'fixed' ? Math.max(max, el.offsetHeight) : max;
    }, 0);

    const galleryTop = gallery.getBoundingClientRect().top;
    if (galleryTop >= offset - 1) return;
    window.scrollTo({ top: Math.max(0, Math.round(galleryTop + window.scrollY - offset)), behavior: 'smooth' });
  });
}
